import { render, staticRenderFns } from "./payoutdetails.vue?vue&type=template&id=67637220"
import script from "./payoutdetails.vue?vue&type=script&lang=js"
export * from "./payoutdetails.vue?vue&type=script&lang=js"
import style0 from "./payoutdetails.vue?vue&type=style&index=0&id=67637220&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports